// Puantaj motorunun ürettiği anomali kodları (motorun `Anomalies` sınıfı — TÜMÜ, 13 kod).
// Sıra, çeviri tablosuyla (Plan 3, Task 2) birebir aynıdır.
export const ANOMALY_CODES = [
  'missing_exit',
  'orphan_exit',
  'nested_session',
  'mixed_direction',
  'session_too_long',
  'all_punches_denied',
  'worked_while_on_leave',
  'punches_without_session',
  'denied_punch',
  'unpaired_soft_punch',
  'duplicate_read',
  'implausible_session',
  'implausible_gap',
];

// i18next defaultValue: bilinmeyen kod (motorda var ama çeviri tablosunda henüz yok) HAM koda
// düşer — yeni motor kodu FE'yi kırmaz.
export const anomalyLabel = (t, code) => t(`timesheet.anomaly.${code}`, code);
